export default "__VITE_ASSET__BtsqccNl__"